export const StateActive = 'active';
export const StateDeleted = 'deleted';

